var map = {
	"./DistrictAdmin/Classes/EditClass": [
		21140,
		2614,
		1140
	],
	"./NtnAdmin/Classes/EditClass": [
		56513,
		2614,
		6513
	],
	"./SchoolAdmin/Classes/EditClass": [
		14257,
		2614,
		4257
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 26088;
module.exports = webpackAsyncContext;